import { IChatsAPIErrorResponse } from '@cian/chats-api/lib/browser-entry';

import { TAPIErrors } from '../types/appState';

function isAPIError(obj: {}): obj is IChatsAPIErrorResponse {
  return 'message' in obj && 'errors' in obj;
}

function isNetworkError(obj: {}) {
  return 'cause' in obj && 'stack' in obj && 'name' in obj;
}

function isBadStatusCodeNetworkError(obj: {}) {
  return isNetworkError(obj) && 'statusCode' in obj && 'response' in obj;
}

export function isSomeOfAPIErrors(obj: {}): obj is TAPIErrors {
  return isAPIError(obj) || isBadStatusCodeNetworkError(obj) || isNetworkError(obj);
}
